import { Settings } from '@anytag/app';
import { PartialRouter } from '../../types';

export const SettingsRouter = {
  '/_private-routes/settings': [Settings, {}]
} as const satisfies PartialRouter;
